import { connect } from 'react-redux'
import { withRouter } from 'react-router'

import { rememberPersonAction, simulateLoadAction } from '../actions'
import { getPersonDetails, hasPersons, isGalleryLoading } from '../selectors'
import PersonDetailsComponent from './PersonDetailsComponent'

const mapStateToProps = (state, { params }) => ({
  loaded: !isGalleryLoading(state) && hasPersons(state),
  person: getPersonDetails(state, params),
})

const PersonDetails = withRouter(
  connect(
    mapStateToProps,
    { loadData: simulateLoadAction, cachePerson: rememberPersonAction },
  )(PersonDetailsComponent)
)

export default PersonDetails



// WEBPACK FOOTER //
// ./src/gallery/components/PersonDetails.js